"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DetectFonts_1 = require("./DetectFonts");
exports.DetectFonts = DetectFonts_1.DetectFonts;
